// extracted by mini-css-extract-plugin
module.exports = {"space":"ResendModal_space__f_hWa","err-msg":"ResendModal_err-msg__Bfp7j","email-input":"ResendModal_email-input__4LR9c"};